import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Text,
} from "recharts";
import "../StackedBarChart/StackedBarChart.css";

const data = [
  { name: "Mon", volume: 900, orders: 800, profit: 600, loss: 1000 },
  { name: "Tue", volume: 1000, orders: 900, profit: 700, loss: 800 },
  { name: "Wed", volume: 1300, orders: 1100, profit: 900, loss: 750 },
  { name: "Thu", volume: 1200, orders: 1000, profit: 800, loss: 690 },
  { name: "Fri", volume: 1500, orders: 1200, profit: 1000, loss: 970 },
  { name: "Sat", volume: 1100, orders: 950, profit: 750, loss: 730 },
  { name: "Sun", volume: 1250, orders: 850, profit: 650, loss: 880 },
];

const CustomBarWithRadius = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 5; // Rounded corner radius
  return (
    <path
      d={`M${x},${y + radius} 
         a${radius},${radius} 0 0,1 ${radius},-${radius} 
         h${width - radius * 2} 
         a${radius},${radius} 0 0,1 ${radius},${radius} 
         v${height - radius} 
         h-${width} 
         Z`}
      fill={fill}
    />
  );
};

const StackedBarChart = () => {
  return (
    <>
      <section className="section">
        <div className="stacked-container">
          <div className="stacked-header">
            <h1>
              Weekly Performance Overview <sub style={{color: "blue"}}>(Stacked Bar chart)</sub>
              {/* : Trading Volume, Orders, Profit, and Loss Trends */}
            </h1>
          </div>

          <div className="stacked-parent">
            <div className="stacked-count-wrapper">
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#5662be" }}
                ></i>{" "}
                Volume
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#7a86df" }}
                ></i>{" "}
                Orders
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#b0b8f4" }}
                ></i>{" "}
                Profit
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#f8e6bf" }}
                ></i>{" "}
                Loss
              </div>
            </div>

            <div className="stacked-chart-container">
              <ResponsiveContainer height={300}>
                <ComposedChart
                  data={data}
                  margin={{ top: 10, right: 10, left: 10, bottom: 15 }}
                >
                  <CartesianGrid
                    stroke="#d6d6d6"
                    strokeDasharray="0 0"
                    horizontal={true}
                    vertical={false}
                  />
                  <XAxis
                    dataKey="name"
                    tick={{ fontSize: 14, fill: "#999" }} // Set tick style
                    label={{
                      value: "Days of the Week",
                      position: "insideLeft",
                      offset: 0,
                      style: { fontSize: "14px", fill: "#999" }, // Set label style
                      dy: 20,
                    }}
                  />
                  <YAxis
                    tick={{ fontSize: 14, fill: "#999" }} // Set tick style
                    label={{
                      value: "Count (Units)",
                      angle: -90,
                      position: "insideBottom",
                      offset: 40,
                      style: { fontSize: "14px", fill: "#999" }, // Set label style
                      dx: -20,
                    }}
                  />
                  <Tooltip
                    labelStyle={{
                      fontWeight: "bold",
                      fontSize: "14px", // Updated to match the uniform size
                      color: "#000", // Updated to match font color
                    }}
                    itemStyle={{
                      color: "#999", // Updated to match font color
                      fontSize: "14px", // Updated to match the uniform size
                    }}
                    wrapperStyle={{
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  />
                  <Bar
                    dataKey="volume"
                    stackId="a"
                    fill="#5662be"
                    barSize={window.innerWidth < 600 ? 25 : 35}
                  />
                  <Bar
                    dataKey="orders"
                    stackId="a"
                    fill="#7a86df"
                    barSize={window.innerWidth < 600 ? 25 : 35}
                  />
                  <Bar
                    dataKey="profit"
                    stackId="a"
                    fill="#b0b8f4"
                    barSize={window.innerWidth < 600 ? 25 : 35}
                  />
                  <Bar
                    dataKey="loss"
                    stackId="a"
                    fill="#f8e6bf"
                    barSize={window.innerWidth < 600 ? 25 : 35}
                    shape={<CustomBarWithRadius />}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StackedBarChart;
